import * as React from "react";
import { hashHistory } from "react-router";
import Drawer from "material-ui/Drawer";
import { observer } from "mobx-react";
import { observable, action } from "mobx";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization } from "../../../models/localization";
import { Auth } from "../../../utils/auth";
import List, { ListItem, ListItemText, ListItemIcon } from "material-ui/List";
import Input, { InputLabel, InputAdornment } from "material-ui/Input";
import Menu, { MenuItem } from "material-ui/Menu";
import LoginDlg from "../../dialogs/login";
import RegistrationDlg from "../../dialogs/registration";
import IconButton from "material-ui/IconButton";
import ArrowButton from "material-ui-icons/ArrowForward";
import BottomNavigation, { BottomNavigationAction } from 'material-ui/BottomNavigation';
import RestoreIcon from 'material-ui-icons/Restore';
import FavoriteIcon from 'material-ui-icons/Favorite';
import LocationOnIcon from 'material-ui-icons/LocationOn';
import Button from 'material-ui/Button';
import Divider from 'material-ui/Divider';
import { ScreenMode } from "../../../models/enums";
import Paper from "material-ui/Paper";
import Icon from 'material-ui/Icon'
import * as s from "./sideNav.css";


const styles: any = {
  icon: {
    height: "25px",
    width: "25px",
    cursor: "pointer",
  },
  drawer: {
    width: "100%",
    zIndex: 1,
    padding: "0",
  },
  label: {
    width: "100%",
    justifyContent: "left",
    textAlign: "left",
  },
  tabletNav: {
    height: "100%",
    width: "6.6vw",
    position: "fixed",
  },
  desktopNav: {
    height: "100%",
    width: "15.6vw",
    position: "fixed",
  }
}

@observer
export default class SideNav extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.store.viewState.scrollToRecommendedOps) {
      return true
    }
    return false
  }
  componentDidMount():void {
    this.setHighlightedTab();  
  }
  componentDidUpdate():void {
    this.setHighlightedTab();
  }
  setHighlightedTab = (): void => {
    const location: string = window.location.hash
    let index: number = -1;
    switch (location) {
      case "#/home":
        index = 1;
        break;
      case "#/#/home":
        index = 1;
        break;
      case "#/profile":
        index = 2;
        break;
      case "#/profile/saved-ops":
        index = 3;
        break;
      case "#/gettingStarted":
        index = 5;
        break;
    }
    for (let c = 1; c < 6; c++) {
      document.getElementsByTagName("button")[c].style.backgroundColor = "#F6F8F8";
    }
    if (index > 0) {
      document.getElementsByTagName("button")[index].style.backgroundColor = "#0072CE40";
    }
  }

  logoff = (): void => {
    this.props.store.viewState.closeDrawer();
    Auth.logout(this.props.store.viewState.clearData);
  }

  onChange = (index: number, location: string, scroll?: boolean): void => {
    for (let c = 1; c < 6; c++) {
      document.getElementsByTagName("button")[c].style.backgroundColor = "#F6F8F8";
    }
    if (index > 0) {
      document.getElementsByTagName("button")[index].style.backgroundColor = "#0072CE40";
    }
    if (scroll) { this.props.store.viewState.setScrollToSearchBar(true); }
    hashHistory.push(location);
  }


  renderSideNav(): JSX.Element[] {
    let local: ILocalization = this.props.store.localization.fields;
    let items: JSX.Element[] = []; 
    const showNotifications: boolean = false; // temporary until notification model is implemented
    if (Auth.isAuthenticated) {
      items.push(<List key="sidenav" style={styles.drawer} className={s.desktoptNav}>
        <div className={s.desktopNavHeader}>
          <span className={s.desktopNavGreeting} >{local.nav.greeting}</span><br />
          <span className={s.desktopNavUser}>{Auth.userName}</span><br />
          <Icon><img src={local.icons.user} style={styles.icon} className={s.desktopNavIcon} /></Icon>
        </div>
        <div className={s.leftWrapper}>
          <Button
            id="navBtn"
            className={s.btn}
            color="secondary"
            key="sidenav-home"
            style={styles.label}
            onClick={() => this.onChange(1, "/home")}>
            <Icon className={s.desktopIcon} >
              <img src={local.icons.home} style={styles.icon} />
            </Icon>{local.sideNav.homePage}
          </Button>
          <Divider />
          <Button
            className={s.btn}
            color="secondary"
            key="sidenav-profile"
            style={styles.label}
            onClick={() => this.onChange(2, "/profile")}
          >
            <Icon className={s.desktopIcon} >
              <img src={local.icons.profile} style={styles.icon} />
            </Icon>{local.sideNav.myInfo}</Button>
          <Divider />
          <Button className={s.btn} color="secondary" key="sidenav-saved" style={styles.label}
            onClick={() => this.onChange(3, "/profile/saved-ops")} ><Icon className={s.desktopIcon} ><img src={local.icons.savedStar} style={styles.icon} /></Icon>{local.sideNav.saved}</Button>
          <Divider />
          <Button className={s.btn} color="secondary" key="sidenav-search" style={styles.label}
            onClick={() => this.onChange(4, "/home", true)}><Icon className={s.desktopIcon} ><img src={local.icons.search} style={styles.icon} /></Icon>{local.sideNav.search}</Button>
          <Divider />
          {showNotifications && <Button className={s.btn} color="secondary" key="sidenav-notifications" style={styles.label} ><Icon className={s.desktopIcon} ><img src={local.icons.notification} style={styles.icon} /></Icon>{local.sideNav.notifications}</Button>}
          {showNotifications && <Divider />}
          <Button className={s.btn} color="secondary" key="sidenav-start" style={styles.label}
            onClick={() => this.onChange(5, "/gettingStarted")}><Icon className={s.desktopIcon} ><img src={local.icons.hand} style={styles.icon} /></Icon>{local.sideNav.quickStart}</Button>
          <Divider />
          <Button className={s.btn} color="secondary" key="sidenav-logout" style={styles.label} onClick={this.logoff}  ><Icon className={s.desktopIcon} ><img src={local.icons.blackLogoff} style={styles.icon} /></Icon>{local.sideNav.logout}</Button>
          <Divider />

        </div>
      </List>);
    }
    return items;
  }

  renderCollapsedNav(): JSX.Element[] {
    let local: ILocalization = this.props.store.localization.fields;
    let items: JSX.Element[] = [];
    const showNotifications: boolean = false;

    if (Auth.isAuthenticated) {
      items.push(<List key="sidenav" style={styles.drawer} className={s.desktoptNav}>
        <div className={s.desktopNavHeader}>
          <span className={s.desktopNavGreeting} >{local.hello}</span><br />
          <Icon><img src={local.icons.user} style={styles.icon} className={s.desktopNavIcon} /></Icon>
        </div>
        <div className={s.centerWrapper}>
          <Button id="navBtn" color="secondary" key="sidenav-home" style={{ minWidth: 0, width: "100%", paddingLeft: 0, paddingRight: 0 }} onClick={() => this.onChange(1, "/home")}><Icon ><img src={local.icons.home} style={styles.icon} /></Icon></Button>
          <Divider />
          <Button id="navBtn" color="secondary" key="sidenav-profile" style={{ minWidth: 0, width: "100%", paddingLeft: 0, paddingRight: 0 }} onClick={() => this.onChange(2, "/profile")}><Icon  ><img src={local.icons.profile} style={styles.icon} /></Icon></Button>
          <Divider />
          <Button id="navBtn" color="secondary" key="sidenav-saved" style={{ minWidth: 0, width: "100%", paddingLeft: 0, paddingRight: 0 }} onClick={() => this.onChange(3, "/profile/saved-ops")}><Icon  ><img src={local.icons.savedStar} style={styles.icon} /></Icon></Button>
          <Divider />
          <Button id="navBtn" color="secondary" key="sidenav-search" style={{ minWidth: 0, width: "100%", paddingLeft: 0, paddingRight: 0 }} onClick={() => this.onChange(4, "/home", true)}><Icon><img src={local.icons.search} style={styles.icon} /></Icon></Button>
          <Divider />
          {showNotifications && <Button color="secondary" key="sidenav-notifications" style={{ minWidth: 0, width: "100%", paddingLeft: 0, paddingRight: 0 }} ><Icon  ><img src={local.icons.notification} style={styles.icon} /></Icon></Button>}
          {showNotifications && <Divider />}
          <Button id="navBtn" color="secondary" key="sidenav-start" style={{ minWidth: 0, width: "100%", paddingLeft: 0, paddingRight: 0 }} onClick={() => this.onChange(5, "/gettingStarted")}><Icon  ><img src={local.icons.hand} style={styles.icon} /></Icon></Button>
          <Divider />
          <Button color="secondary" key="sidenav-logoff" style={{ minWidth: 0,  width: "100%", paddingLeft: 0, paddingRight: 0 }} onClick={this.logoff}><Icon  ><img src={local.icons.blackLogoff} style={styles.icon} /></Icon></Button>
          <Divider /></div>
      </List>);
    }

    return items;
  }
  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const c: any = mode === ScreenMode.Desktop ? styles.desktopNav : styles.tabletNav;
    return <div style={c}>
      {mode === ScreenMode.Desktop && this.renderSideNav()}
      {mode === ScreenMode.Tablet && this.renderCollapsedNav()}
    </div> 
  }
}


// WEBPACK FOOTER //
// ./src/components/app/sideNav/index.tsx